import { render, staticRenderFns } from "./AddressFormat.vue?vue&type=template&id=f4e8bc8a&"
import script from "./AddressFormat.vue?vue&type=script&lang=js&"
export * from "./AddressFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports